module.exports = __webpack_public_path__ + "static/media/medium-icon.0b169e6b.svg";